<ion-item [formGroup]="parent">
  <ion-textarea
    [formControlName]="question.key"
    [attr.disabled]="question.disabled"
    [attr.readonly]="question.readonly"
  >
  </ion-textarea>
</ion-item>
